var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19302 0.562437C9.02659 0.218726 8.67489 0 8.28865 0C7.90241 0 7.55386 0.218726 7.38429 0.562437L5.36517 4.69635L0.855896 5.35878C0.479077 5.41502 0.165061 5.67749 0.0488749 6.03682C-0.067311 6.39616 0.0268937 6.79299 0.296947 7.05858L3.56899 10.2801L2.79651 14.8327C2.73371 15.2077 2.89072 15.5889 3.2016 15.8107C3.51247 16.0326 3.92383 16.0607 4.26297 15.8826L8.29179 13.7422L12.3206 15.8826C12.6598 16.0607 13.0711 16.0357 13.382 15.8107C13.6929 15.5858 13.8499 15.2077 13.7871 14.8327L13.0115 10.2801L16.2835 7.05858C16.5536 6.79299 16.6509 6.39616 16.5316 6.03682C16.4122 5.67749 16.1014 5.41502 15.7246 5.35878L11.2121 4.69635L9.19302 0.562437Z",
    fill: "#2D65F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon1);
export default __webpack_public_path__ + "static/media/category_icon1.8b9d203b48a9aa96ccd9e01ee6327781.svg";
export { ForwardRef as ReactComponent };